import { MIN_SPACE_DIM_FEET } from 'data/constants';
import { LevelType, PositionType } from 'data/types';
import { getEffectiveFootprintPolygons } from 'utils/footprint-polygons';
import { computeUncoveredVoids, polygonAreaAbs } from 'utils/space-gap-fill';
import { getSpaceVertices } from 'utils/space-polygon';

const MIN_NEW_SPACE_AREA_SQFT = MIN_SPACE_DIM_FEET * MIN_SPACE_DIM_FEET;

export function isFootprintFullyCovered(
  level: LevelType | null | undefined
): boolean {
  if (!level) return false;

  const footprints = getEffectiveFootprintPolygons(level);
  if (footprints.length === 0) return false;

  const spacePolygons: PositionType[][] = [];
  for (const section of level.sections) {
    for (const space of section.spaces) {
      if (space.position) {
        const relative = getSpaceVertices(space);
        if (relative.length >= 3) {
          spacePolygons.push(
            relative.map((v) => ({
              x: space.position!.x + v.x,
              y: space.position!.y + v.y
            }))
          );
        }
      }
    }
  }
  if (spacePolygons.length === 0) return false;

  const voids = computeUncoveredVoids(spacePolygons, footprints);
  const uncoveredArea = voids.reduce(
    (sum, voidPolygon) => sum + polygonAreaAbs(voidPolygon),
    0
  );
  return uncoveredArea < MIN_NEW_SPACE_AREA_SQFT;
}
